import { useLocalStorage } from '@mantine/hooks'
import type { ExtraPackage } from 'src/features/ExtraPackage/api/types'
import { useMyInfo } from 'src/services/apollo/auth'
import type { UANewbiePackSnapshot } from '../types'
import {
  UA_NEWBIE_PACK_PACKS_PRESETS,
  UA_NEWBIE_PACK_SNAPSHOT_PRESETS,
  type PacksPresetKey,
  type SnapshotPresetKey,
} from './presets'

export const DEBUG_STORAGE_KEYS = {
  enabled: 'debug-ua-newbie-pack-widget',
  snapshotPreset: 'debug-ua-newbie-pack-snapshot-preset',
  packsPreset: 'debug-ua-newbie-pack-packs-preset',
} as const

/** True only for admins when the `enable-debug` master flag AND the widget toggle are both on. */
export function useUANewbiePackDebugActive(): boolean {
  const { data: userInfo } = useMyInfo()
  const [enableDebug] = useLocalStorage<boolean>({ key: 'enable-debug' })
  const [widgetEnabled] = useLocalStorage<boolean>({
    key: DEBUG_STORAGE_KEYS.enabled,
  })
  return (
    userInfo?.isAdmin === true && enableDebug === true && widgetEnabled === true
  )
}

export function useDebugSnapshotOverride(): UANewbiePackSnapshot | null {
  const active = useUANewbiePackDebugActive()
  const [preset] = useLocalStorage<SnapshotPresetKey | ''>({
    key: DEBUG_STORAGE_KEYS.snapshotPreset,
  })
  if (!active || !preset) return null
  return UA_NEWBIE_PACK_SNAPSHOT_PRESETS[preset] ?? null
}

export function useDebugPacksOverride(): ExtraPackage[] | null {
  const active = useUANewbiePackDebugActive()
  const [preset] = useLocalStorage<PacksPresetKey | ''>({
    key: DEBUG_STORAGE_KEYS.packsPreset,
  })
  if (!active || !preset) return null
  return UA_NEWBIE_PACK_PACKS_PRESETS[preset] ?? null
}
